<script setup lang="ts">
import { ColorPicker } from '@/components/color-picker';
import { SvgColorPalette } from '@repo/icons';

import { type ColorPalette, useFabricStore } from '@/store/fabric.ts';
import { useRelationStore, useSelectionStore } from '@repo/stores';
import { type Shape, useStyle3d } from '@repo/style3d';
import { useParamStore } from '@/store/param.ts';
import { useRouter } from 'vue-router';

const defaultPalette = [
  {
    colorNo: '1',
    color: '#A9D8F6'
  },
  {
    colorNo: '2',
    color: `#CEE2E0`
  },
  {
    colorNo: '3',
    color: `#F9F0EB`
  },
  {
    colorNo: '4',
    color: `#D69F98`
  },
  {
    colorNo: '5',
    color: `#B7ABB9`
  }
];

const fabricStore = useFabricStore();
const selectionStore = useSelectionStore();
const relationStore = useRelationStore();
const paramStore = useParamStore();

const router = useRouter();
const updateUrlQuery = (shape: Shape, c: Pick<ColorPalette, 'color'> & Partial<ColorPalette>) => {
  const { type, id } = paramStore.resourceParam.fabricResource;
  if (shape.fabric?.type === type && shape.fabric?.id === id) {
    const color = encodeURIComponent(JSON.stringify(c));
    router.replace({
      query: {
        ...router.currentRoute.value.query,
        color
      }
    });
  }
};

const { changeFabricColor, selectMaterial } = useStyle3d();

const onClickColor = async (c: Pick<ColorPalette, 'color'> & Partial<ColorPalette>) => {
  const { selectedFabricId } = selectionStore;
  const found = relationStore.shapeList.find(item => item.id === selectedFabricId);
  if (selectedFabricId === '' || found) {
    const materialIndex = found?.materialIndex;
    const filteredList = relationStore.shapeList.filter(item => {
      if (materialIndex === undefined) {
        return item.materialIndex === 0 || item.materialIndex === undefined;
      }
      return item.materialIndex === materialIndex;
    });

    if (!filteredList?.length) {
      return;
    }
    updateUrlQuery(found || filteredList[0]!, c);

    const updatedList: Shape[] = [];
    for (const item of filteredList) {
      await selectMaterial(item.id);
      await changeFabricColor(c.color);
      updatedList.push({ ...item, color: c.color });
    }
    relationStore.updateShape(updatedList);

    selectionStore.setSelectedFabric('');
  } else {
    // 可能是钮扣之类的
    await selectMaterial(selectedFabricId);
    await changeFabricColor(c.color);
  }
};

</script>

<template>
  <div :class="$style.container">
    <div
      v-for="p of fabricStore.palette||defaultPalette"
      :key="p.colorNo"
      :style="{ backgroundColor: p.color }"
      style="width: 30px;height:30px;"
      @click="()=>onClickColor(p)"
    />
    <ColorPicker style="width: 30px;height:30px;" @confirm="(color)=>onClickColor({color})">
      <SvgColorPalette style="width: 100%; height: 100%;" />
    </ColorPicker>
  </div>
</template>

<style module>
.container {
  padding: 20px 10px 50px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
